import { LocalStateKeys } from '@tectonic/types';
import { useEffect } from 'react';
import { usePageFragment, useSharedLocalState } from '../../../hooks';
import { useShallow, useUserProfileWidgetStore } from '../../../store';

import type { ElemasonUserProfileWidget, Nil } from '@tectonic/types';
import type { UserProfileWidgetStore } from '../../../store';

type LocalProfileStore = {
  phone?: Nil<string>;
  code?: Nil<string>;
};

const initialState: LocalProfileStore = {};

const profileSelector = (state: UserProfileWidgetStore) => ({
  details: state.details,
});

const useUserProfileWidget = (widget: ElemasonUserProfileWidget) => {
  const wData = widget.data!;

  const { setSharedState } = useSharedLocalState<LocalProfileStore>(
    LocalStateKeys.PROFILE_STORE,
    initialState
  );

  const { details } = useUserProfileWidgetStore(useShallow(profileSelector));

  const currentStep = useUserProfileWidgetStore(
    (state) => state.currentStep ?? wData.defaultStep
  );

  const fSlug = wData.fragments[currentStep];

  const fragment = usePageFragment(fSlug);

  useEffect(() => {
    const { phoneNumber } = details ?? {};
    const code = phoneNumber ? phoneNumber.country.stdCodes[0] : null;
    const phone = phoneNumber ? phoneNumber.phone : null;
    setSharedState({ phone, code });
  }, [details]);

  return { fragment };
};

export { useUserProfileWidget };
